import React, { useState } from "react";
import "../css/BookMeeting.css";

const BookMeeting = () => {
  const [formData, setFormData] = useState({
    parentName: "",
    studentName: "",
    phone: "",
    email: "",
    grade: "",
    date: "",
    time: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    alert("Meeting Booked Successfully!");
  };

  return (
    <>
      {}
      <section
        className="book-meeting"
        style={{
          backgroundImage:
            "linear-gradient(rgba(12,48,86,0.75), rgba(12,48,86,0.75)), url('/images/mr.jpeg')",
        }}
      >
        <div className="meeting-overlay">
          <div className="container">
            <h1>Book a Meeting</h1>
            <p>
              Schedule a meeting with our admission counsellor and get complete
              guidance about admissions.
            </p>
          </div>
        </div>
      </section>

      {}
      <section className="meeting-section">
        <div className="meeting-container">
          <div className="meeting-form">
            <h2>Meeting Request Form</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="parentName"
                placeholder="Parent Name"
                value={formData.parentName}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="studentName"
                placeholder="Student Name"
                value={formData.studentName}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <select
                name="grade"
                value={formData.grade}
                onChange={handleChange}
                required
              >
                <option value="">Select Grade</option>
                <option>Nursery</option>
                <option>LKG</option>
                <option>UKG</option>
                <option>Class 1</option>
                <option>Class 2</option>
                <option>Class 3</option>
                <option>Class 4</option>
                <option>Class 5</option>
                <option>Class 6</option>
                <option>Class 7</option>
                <option>Class 8</option>
                <option>Class 9</option>
                <option>Class 10</option>
              </select>

              <div className="date-time">
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                />

                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  required
                />
              </div>

              <textarea
                name="message"
                rows="5"
                placeholder="Your Message (Optional)"
                value={formData.message}
                onChange={handleChange}
              />

              <button type="submit">Book Meeting</button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookMeeting;
